import React, { Component } from 'react';
import rcf from './gallery-rcf.jpg';
import kelso from './gallery-kelso.jpg';
import sportcoupe from './gallery-sportcoupe.jpg';
import drift from './gallery-drift.jpg';

class Gallery extends Component {
  render() {
    return (
      <div className="container-fluid">

        <h2>
          Gallery
        </h2>

        <h4>
          Lexus RC F
        </h4>
        <div>
          <img src={rcf} className="gallery-rcf" alt="rcf" />
        </div>
        <h3>
          Kelso Cruise
        </h3>
        <div>
          <img src={kelso} className="gallery-kelso" alt="kelso" />
        </div>
        <h3>
          Lexus SC400
        </h3>
        <div>
          <img src={sportcoupe} className="gallery-sportcoupe" alt="sportcoupe" />
        </div>
        <h5>
          PARC Drift
        </h5>
        <div>
          <img src={drift} className="gallery-drift" alt="drift" />
        </div>


      </div>
    );
  }
}

export default Gallery;
